import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import {
  Divider,
  IconButton,
  ListItemIcon,
  MenuItem,
  Typography,
} from "@mui/material";
import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import IconWrapper from "../../../common/components/functional/icons/IconWrapper";
import { ReactComponent as ChatIcon } from "../../../common/icons/chatBubble.svg";
import { ReactComponent as DeleteIcon } from "../../../common/icons/delete.svg";

type Props = {
  hasStatusMessage: boolean;
  disabled?: boolean;
  onOpen: () => void;
  onDelete: () => void;
};

const StatusMessageMenuItem = ({
  hasStatusMessage,
  disabled = false,
  onOpen,
  onDelete,
}: Props) => {
  const { t } = useTranslation();

  const handleDelete = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onDelete();
  };

  return (
    <>
      <MenuItem disabled={disabled} onClick={onOpen}>
        <ListItemIcon>
          <IconWrapper
            icon={ChatIcon}
            sx={{
              width: 24,
              height: 24,
              "& path": {
                fill: "black",
                fillOpacity: 0.87,
              },
            }}
          />
        </ListItemIcon>
        <Typography variant="header" fontWeight="600" sx={{ flex: 1 }}>
          {hasStatusMessage
            ? t("common:editStatusMessage")
            : t("common:setStatusMessage")}
        </Typography>
        {hasStatusMessage && (
          <IconButton
            aria-label={t("common:deleteStatusMessage")}
            disabled={disabled}
            edge="end"
            size="small"
            onClick={handleDelete}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <DeleteIcon />
          </IconButton>
        )}
        <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "24px" }}>
          <ArrowRightIcon />
        </ListItemIcon>
      </MenuItem>
      <Divider
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.2)",
        }}
      />
    </>
  );
};

export default StatusMessageMenuItem;
